import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=273c09bc&lang=pug"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports